import { CE } from './ce';

export class SC extends CE {}
